/**
 * Packaging OS — non-component helpers shared by catalog pages (Phase 1O-B).
 *
 * Kept in a separate file so eslint react-refresh/only-export-components
 * stays happy in the .tsx files that export only React components.
 */

import { useState } from "react";

export function useCatalogPage(): {
  page: number;
  setPage: (next: number) => void;
} {
  const [page, setPage] = useState<number>(1);
  return { page, setPage };
}

export function formatDate(iso: string): string {
  return iso.slice(0, 10);
}

export function joinList(list: string[]): string {
  if (list.length === 0) return "—";
  return list.join(", ");
}
